export default {
  crmAddress: 'https://finelec.crmservice.fi',
  modules: ['quotes'],
  quotes: {
    fields: [
      'cf_1544', // Työtilaus
      'subject',
      'stage',
      'entity_no',
      'created_at',
      'ship_street',
      'ship_zip_code',
      'ship_city',
      'cf_tyon_suorittaja',
      'cf_1571', // Kiinteistöhuoltoyhtiö
      'cf_1572', // Puh. Kiinteistöhuoltoyhtiö
      'cf_1573', // Kiinteistönhoitaja
      'cf_1574', // Puh. Kiinteistönhoitaja
      'cf_1561', // Sisäänpääsy
      'cf_1545', // Yhteenveto suoritetusta työstä
      'cf_1575', // Kohteen lisätiedot
      'description' // Laitekanta
    ],
    status: {
      started: 'Työ aloitettu',
      completed: 'Delivered',
      inProgress: 'Reviewed'
    }
  }
}
